<template>
  <div class="homecare-list-container">
    <div class="search media">
      <div class="media-body">
        <search-input
          :placeholder="$t('label.search_home')"
          @search="searchHomecare"
        ></search-input>
      </div>
      <div class="ms-3">
        <filter-dropdown
          :header="'คัดกรองสถานะใบงาน'"
          :rows="rows"
          :type="'radio'"
          @filterSubmit="filterHomecare"
        ></filter-dropdown>
      </div>
    </div>
    <div class="col p-0 homecare-list">
      <homecare-navigation :jobs="jobs" />
      <infinite-loading
        ref="infiniteLoading"
        :identifier="infiniteLoadingIdentifier"
        spinner="spiral"
        @infinite="infiniteHandler"
      >
        <span slot="no-results" />
        <span slot="no-more" />
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SearchInput from "@/components/helper/SearchInput";
import FilterDropdown from "@/components/helper/Dropdown";
import InfiniteLoading from "vue-infinite-loading";
import { getCookie, Auth } from "@/lib/cookie";
import HomecareNavigation from "./HomecareNavigation";

export default {
  components: {
    SearchInput,
    InfiniteLoading,
    FilterDropdown,
    HomecareNavigation
  },
  data() {
    return {
      loading: false,
      jobs: [],
      page: 1,
      keyword: "",
      filter: "",
      infiniteLoadingIdentifier: 0,
      rows: [
        {
          key: "",
          value: "ทั้งหมด"
        },
        {
          key: "OPN",
          value: this.$t("feature.homecare.status.OPN")
        },
        {
          key: "WINP",
          value: this.$t("feature.homecare.status.WINP")
        },
        {
          key: "INP",
          value: this.$t("feature.homecare.status.INP")
        },
        {
          key: "RVW",
          value: this.$t("feature.homecare.status.RVW")
        },
        {
          key: "CLS",
          value: this.$t("feature.homecare.status.CLS")
        },
        {
          key: "CNC",
          value: this.$t("feature.homecare.status.CNC")
        }
      ]
    };
  },
  methods: {
    infiniteHandler($state) {
      if (!this.loading) {
        this.loadHomecare()
          .then(result => {
            this.loading = false;
            this.jobs = this.jobs.concat(result.job_orders);
            if (result.last_page !== this.page) {
              this.page += 1;
              $state.loaded();
            } else {
              $state.complete();
            }
          })
          .catch(e => {
            $state.complete();
            this.loading = false;
            throw e;
          });
      }
    },
    loadHomecare() {
      this.loading = true;
      return axios
        .get(`${process.env.HOST}/admin/homecares`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          },
          params: {
            page: this.page,
            project_id: this.$route.params.projectId,
            limit: 10,
            job_order_status_code: this.filter,
            address_no: this.keyword
          }
        })
        .then(res => res.data);
    },
    searchHomecare(keyword) {
      this.keyword = keyword;
      this.resetLoading();
    },
    filterHomecare(filter) {
      this.filter = filter;
      this.resetLoading();
    },
    resetLoading() {
      this.jobs = [];
      this.page = 1;
      this.infiniteLoadingIdentifier += 1;
    },
    setJobStateReadBy(id) {
      const job = this.jobs.find(j => j.job_order_id === id);
      if (job) {
        job.is_read = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 15px;
}
.homecare-list-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.homecare-list {
  overflow: auto;
}
</style>
